import { otto } from "../chunks/common-nexus-client-BxVeVD8v.mjs";
import { asExport } from "../chunks/common-core-client-BYCqsbss.mjs";
import { noop } from "../chunks/common-function-client-BVBvJr6Z.mjs";
const accessibility = /*           */ asExport(otto, "ally", {});
const srSpeak = /*           */ asExport(
  accessibility,
  "srSpeak",
  noop
);
const focus = /*           */ asExport(accessibility, "focus", noop);
export {
  accessibility,
  focus,
  srSpeak
};
/*                                            */
